import React from "react";
import { Grid, makeStyles } from "@material-ui/core";
import ArrowRightAltIcon from "@material-ui/icons/ArrowRightAlt";
import SyncAltIcon from "@material-ui/icons/SyncAlt";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { IconButton } from "@material-ui/core";
import locale from "@bonliva-crm/locale";

import { TravelRequestReturnRide } from "./TravelRequest";
import { TravelRequestRide } from "./TravelRequestRide";
import { TransportationTypeField } from "./TransportationTypeField";
import { Option } from "@components/formx/Select";
import { RideType } from "@bonliva-crm/shared";
import { RadioGroup } from "@components/formx";

type Props = {
  name: string;
  ride: TravelRequestReturnRide;
  countries: Option[];
  readonly: boolean;
  disabled: boolean;
  allowToAddRide: boolean;
  addRide: () => void;
  removeRide: () => void;
};

export function TravelRequestRideSection({
  name,
  ride,
  countries,
  readonly,
  disabled,
  addRide,
  removeRide,
  allowToAddRide
}: Props) {
  const classes = useStyles({});

  const icon = React.createElement(
    ride.rideType === RideType.OneWay ? ArrowRightAltIcon : SyncAltIcon,
    { className: classes.arrow }
  );

  return (
    <Grid key={name} item xs={12} container spacing={3}>
      <Grid item xs={12}>
        <Grid item xs={12} className={classes.transportationType}>
          <TransportationTypeField name={`${name}.transportationType`} exclusive />
          <RadioGroup
            name={`${name}.rideType`}
            GroupProps={{
              className: classes.radioGroup
            }}
            options={Object.keys(RideType).toLabelValue((x) => locale.rideType[x])}
          />
        </Grid>

        <div className={classes.ride}>
          <TravelRequestRide
            className={classes.rideItem}
            name={`${name}.dir1`}
            data={ride.dir1}
            countries={countries}
          />

          {icon}

          <TravelRequestRide
            className={classes.rideItem}
            name={`${name}.dir2`}
            data={ride.dir2}
            countries={countries}
            disabled={{ date: ride.rideType === RideType.OneWay }}
          />
          {!readonly && (
            <>
              <IconButton onClick={addRide} disabled={disabled}>
                <AddIcon />
              </IconButton>
              <IconButton disabled={allowToAddRide || disabled} onClick={removeRide}>
                <RemoveIcon />
              </IconButton>
            </>
          )}
        </div>
      </Grid>
    </Grid>
  );
}

const useStyles = makeStyles((theme) => ({
  arrow: {
    color: "gray"
  },
  ride: {
    ...theme.mixins.childrenMarginRight(8),
    display: "flex",
    alignItems: "center",
    "&:not(:last-child)": {
      marginBottom: 16
    }
  },
  rideItem: {
    padding: 16,
    flex: 1
  },
  transportationType: {
    position: "relative",
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(1)
  },
  radioGroup: {
    flexDirection: "row",
    paddingLeft: theme.spacing(2)
  }
}));
